module.exports = __webpack_public_path__ + "img/black.535f4b8c.png";